goog.provide('el8.ptdata.vitalsCollections');

goog.require('el8.model.base');


el8.ptdata.vitalsCollections = (function() {

    var _class = function(spec) {
        this.populate(spec);
    };
    _class.inheritsFrom(el8_Entity);

    _class.prototype.populate = function(spec) {
        spec = spec || {};
        if (spec.bps) {
            spec.bps = el8.util.keysFromUnderscoreToCamel(spec.bps);
        }
        this.parent.populate.call(this, spec);
    };

    _class.addIntProperty('noteId', true);

    _class.addDateTime('collectedDate', true);

    _class.addProperty('bps', true, []);
    
    _class.addStringProperty('hr', true);
    _class.addStringProperty('hrNote', true);

    _class.addStringProperty('temperature', true);
    _class.addStringProperty('tempNote', true);

    _class.addStringProperty('rr', true);
    _class.addStringProperty('rrNote', true);

    _class.addStringProperty('height', true);
    _class.addStringProperty('htNote', true);

    _class.addStringProperty('weight', true);
    _class.addStringProperty('wtNote', true);

    _class.addStringProperty('bmi', true);
    
    _class.addStringProperty('oxygen', true);
    _class.addStringProperty('oxygenNote', true);

    _class.addStringProperty('hc', true);
    _class.addStringProperty('hcNote', true);

    _class.addStringProperty('pain', true);
    _class.addStringProperty('painNote', true);


    var that = new el8_EntitySet({
        model: function(spec) {
            return new _class(spec);
        },
        saveFn: function(item, successCb, errorCb, opts) {
            // for now, these are always getting saved to NonvisitNotes
            opts = opts || {};
            $.el8_ajax({
                type: 'POST',
                url: el8.service.urls.get('nonVisitVital', [item]),
                async: (opts.async !== false), // defaults true
                data: JSON.stringify(item.asMap(true)),
                success: function(data) {
                    item.populate(data);
                    if (successCb) { successCb(data); }
                },
                error: errorCb
            });
        },
        deleteFn: function(item, successCb, errorCb, opts) {
            opts = opts || {};
            $.el8_ajax({
                type: 'DELETE',
                url: el8.service.urls.get('vitalsCollection', [item]),
                async: (opts.async !== false), // defaults true
                success: function(data) {
                    if (successCb) { successCb(); }
                },
                error: errorCb
            });
        }
    });

    return that;

})();
